<template>
  <v-container fluid class="pa-0">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="$apollo.loading"
      :items-per-page-options="[10, 25, 50, 100]"
      :search="search"
      v-bind="pagingOptions"
      :hide-default-footer="hideFooter"
      v-model="selected"
      show-select
      hide-default-footer
    >
      <template v-slot:item.itineraryStartDate="{ item }">{{
        item.itineraryStartDate | formatDate
      }}</template>
      <template v-slot:item.firstServiceStartDate="{ item }">{{
        item.firstServiceStartDate | formatDate
      }}</template>
      <template v-slot:item.createdAt="{ item }">{{
        item.createdAt | formatDate
      }}</template>
      <template v-slot:item.approvedAt="{ item }">{{
        item.approvedAt | formatDate
      }}</template>
      <template v-slot:item.exportedAt="{ item }">{{
        item.exportedAt | formatDate
      }}</template>
      <template v-slot:item.supplierInvoiceDate="{ item }">{{
        item.supplierInvoiceDate | formatDate
      }}</template>
      <template v-slot:item.itineraryReference="{ item }">
        <reference-label
          v-model="item.itineraryReference"
          :itinerary-id="item.itinerary ? item.itinerary.id : ''"
        ></reference-label>
      </template>
      <template v-slot:item.amount="{ item }" v-if="false">
        <v-text-field
          type="number"
          v-model="item.amount"
          min="0"
          class="pt-1 ma-0 short-input"
          @change="onAmountChange(item)"
        ></v-text-field>
      </template>
      <template v-slot:item.approved="{ item }">
        <v-checkbox
          v-model="item.approved"
          primary
          hide-details
          :disabled="true"
          class="ma-0"
        ></v-checkbox>
      </template>
      <template v-slot:item.itineraryReference="{ item }">
        <reference-label
          v-model="item.itineraryReference"
          :itinerary-id="item.itinerary ? item.itinerary.id : ''"
          new-tab
        ></reference-label>
      </template>

      <template v-slot:item.vatAmount="{ item }">
        {{ Number(item.vatAmount).toFixed(2) }}
      </template>
      <template v-slot:item.netAmount="{ item }">
        {{ Number(item.netAmount).toFixed(2) }}
      </template>
      <template v-slot:item.paid="{ item }">
        {{ Number(item.paid).toFixed(2) }}
      </template>
      <template v-slot:item.balance="{ item }">
        {{ Number(item.balance).toFixed(2) }}
      </template>
      <template v-slot:item.paymentAmount="{ item }">
        <v-text-field
          type="number"
          v-model="item.paymentAmount"
          min="0"
          class="pt-1 ma-0 short-input"
          @change="onAmountChange(item)"
        ></v-text-field>
      </template>
      <template v-slot:footer>
        <v-layout justify-space-around class="pa-2">
          <list-totals v-model="totalsColumns" :items="items"></list-totals>
        </v-layout>
      </template>
    </v-data-table>
    <v-row v-if="debug">
      <v-col>
        <code>--{{ selected }}--</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DefaultListActions from "../../shared/DefaultListActions";
import ReferenceLabel from "../../shared/labels/ReferenceLabel";
import { pagingOptions } from "../../../../helpers/index";
import ListTotals from "../../shared/ListTotals.vue";
import { Ref } from "vue-property-decorator";
export default {
  name: "pi-table-batch-pay",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    hideFooter: {
      type: Boolean,
      defaultd: () => false,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },

  components: { DefaultListActions, ListTotals, ReferenceLabel },

  data() {
    return {
      debug: false,
      pagingOptions,
      selected: this.selectedItems.filter((value) =>
        this.items.includes(value)
      ),
    };
  },

  computed: {
    totalsColumns() {
      const cols = [
        "amount",
        "paid",
        "vatAmount",
        "netAmount",
        "balance",
        "paymentAmount",
      ];
      return this.headers.filter((h) => cols.indexOf(h.name) != -1);
    },
    totalPrice() {
      let total = 0;
      if (this.items.length > 0) {
        total = this.items.reduce(
          (t, item) => Number(t) + Number(item.amount),
          total
        );
      }
      return total.toFixed(2);
    },
  },

  watch: {
    selected(val) {
      this.$emit("updateSelection", {
        items: [...this.items],
        selected: [...val],
      });
    },
  },

  methods: {
    onAmountChange(item) {
      this.$emit("amount-change", item);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/finances/purchase-invoice-payments/PiTableBatchPay.vue